import React,{memo} from 'react'
import intl from "../../../../i18n/intl";
import ShopifyModal from "../../../../components/ShopifyModal";
const NotSourcingCompleteModal = memo(({open, setPaymentData,paymentData}) => {
  return (
    <div>
      <ShopifyModal
        id="not-sourcing-complete-modal"
        open={open}
        onClose={()=>setPaymentData((prevValue)=>({...prevValue,isNotSourcing:false}))}
        heading={intl.get("Sourcing not completed")}
        primaryAction={{
          content: intl.get('Continue to pay'),
          onAction: ()=>setPaymentData((prevValue)=>({...prevValue,isNotSourcing:false,isShowBulkPaymentModal:true})),
        }}
        secondaryActions={[
          {
            content: intl.get('Cancel'),
            onAction: ()=>setPaymentData((prevValue)=>({...prevValue,isNotSourcing:false})),
          },
        ]}
      >
            <p>
            {`Some products haven’t completed sourcing yet. For the smoothest experience, we suggest waiting until all items are ready. You can also proceed now—your order will be split, and payment will only apply to the sourced items.`}
            </p>
      </ShopifyModal>
    </div>
  )
})

export default NotSourcingCompleteModal
